import { Map } from 'immutable';
import { SORT_TYPES } from 'src/components/Sorting/constants';
import { CHANGE_SORTING } from '../constants/sorting';
import { SEARCH_SUCCESS } from '../constants/search';
import { getUrlParams } from '../../../utils/uriUtils';

const getInitialState = () => {
  let field;
  let order;
  const clientSorting = getUrlParams().sort_by;
  if (clientSorting) {
    [field, order] = clientSorting.split(',');
  } else {
    const [defaultSorting] = SORT_TYPES;
    field = defaultSorting.id;
    const [{ order: defaultOrder }] = defaultSorting.types;
    order = defaultOrder;
  }
  return Map({ field, order, pToken: null });
};

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case CHANGE_SORTING: {
      const { field, order } = action.payload;
      return state.withMutations((s) =>
        s.set('field', field).set('order', order),
      );
    }

    case SEARCH_SUCCESS: {
      const { sort_ptoken, sort_by } = action.payload;
      return state.withMutations((s) =>
        s.set('pToken', sort_ptoken).set('originalSortBy', sort_by),
      );
    }

    default:
      return state;
  }
}
